export default {
  title: 'Log in',
  username: 'Username or email',
  password: 'Password',
  logways1: 'Login in with phone',
  logways2: 'Log in with password',
  forgot: 'Forgot password?',
  login: 'Log in',
  socialAccount: 'OR',
  customerInfo: 'Find solutions with the help of global talents',
  customerIn: 'Publish Tasks',
  userInfo: 'Earn points with various tasks',
  userIn: 'Do Tasks',
  js: {
    error: 'Failure',
    success: 'Success'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/login.js